/**Filtro para la consulta de los viajes de ruta  */
export interface FiltroViajeList {


    FechaCreacionInicio?: Date | string | null;
    FechaCreacionFinal?: Date | string | null;
    IdSucursalOrigen?: number | null;
    IdSucursalDestino?: number | null;
    IdSucursalOrigenODestino: number | null;
    IdCamion?: number | null;
    IdChoferRuta?: number | null;
    Folio?: number | null;
    Status?: StatusViajeRuta | null;
    Limit: number | null;
}

/**Modelo para crear un viaje de ruta */
export interface NuevoViajeRutaModel {


    IdCamion: number;
    IdChoferRuta: number;
    IdSegmento: number;
}

/**Tipo o razon de una sugerencia de segmento para un nuevo viaje de ruta */
export enum TipoSugerenciaSegmento {
    /**Se sugiere esta ruta porque su origen es igual a la sucursal actual y se encuentra en la ruta del camion */
    EnRutaEnSucursal,
    /**Se sugiere porque el origen del segmento es igual al origen de la sucursal actual */
    EnSucursal,
    /**Se sugiere porque el segmento se encuentra en la ruta del camion */
    EnRuta,
    /**Este segmento no se sugiere */
    Ninguna,
}

/**Una sugerencia para un segmento de viaje */
export interface SugerenciaSegmento {


    /**Id del segmento sugerido */
    IdSegmento: number;

    /**Tipo o razon de la sugerencia de este segmento */
    Tipo: TipoSugerenciaSegmento;

    IdSucursalOrigen: number;
    IdSucursalDestino: number;
    NombreSegmento: string;
    NombreSucursalOrigen: string;
    NombreSucursalDestino: string;
}

export enum StatusViajeRuta {
    /**Ya se le asignó un destino y un chofer a ese camión, pero que el camión aún no esta en camino */
    Creado = 0,
    /**El camión ya salió */
    EnTrayecto = 1,

    /**El viaje ya llego a su destino, el siguiente paso ya no le corresponde al viaje si no a las cajas, ya que prosigue la descarga de mercancía */
    Finalizado = 2,

    /**El viaje fue creado antes de ser iniciado.  */
    Cancelado = 3
}

/**
 * Un viaje de un móvil de ruta. En esta entidad se encuentra asignado el chofer al móvil de ruta. El viaje representa un viaje del móvil en un segmento, 
 * es decir, no representa el viaje completo por toda la ruta, si no sólo el viaje entre 2 sucursales
 */
export interface ViajeRuta {



    IdRegistro: number;

    Folio: number;

    /**Usuario que creo el viaje */
    IdUsuario: number;

    /**Id de movil de ruta */
    IdCamion: number;

    /**Id de chofer que realiza este viaje */
    IdChoferRuta: number;

    /**Id de la sucursal de origen del viaje. No son redundantes con respecto al segmento porque consideramos que el segmento puede cambiar su sucursales */
    IdSucursalOrigen: number;

    /**Id de la sucursal destino del viaje. No son redundantes con respecto al segmento porque consideramos que el segmento puede cambiar su sucursales */
    IdSucursalDestino: number;

    /**Segmento en el cual se va a llevar a cabo el viaje */
    IdSegmento: number;

    /**Ruta que traía el camion al momento de crear el viaje */
    IdRuta: number;

    /**Status del viaje */
    Status: StatusViajeRuta;

    /**Fecha de creación del viaje */
    FechaCreacion: Date | string;

    /**Fecha y hora real de salida de este viaje. Un CHECK verifica que no sea null si el Status >= EnTrayecto */
    FechaRealSalida: Date | string | null;
    /**Fecha y hora estimada de llegada del viaje. Un CHECK verifica que no sea null si el Status >=  Finalizo */
    FechaRealLlegada: Date | string | null;

    /**Anomalias que se le han capturado al viaje */
    Anomalias: ViajeRutaAnomalia[];

}

/**Una anomalia es una nota de texto libre que se establece al viaje */
export interface ViajeRutaAnomalia {
    IdRegistro: number;

    /**Viaje al que se le anexa la anomalia */
    IdViajeRuta: number;
    ViajeRuta: ViajeRuta;

    /**Fecha de creación */
    Fecha: Date | string;

    /**Usuario que escribio la anomalia */
    IdUsuario: number;

    /**Texto libre */
    Texto: string;
}

export interface ViajeRutaDto extends ViajeRuta {
    NombreCamion: string;
    NombreChofer: string;
    NombreSucursalOrigen: string;
    NombreSucursalDestinio: string;
    NombreUsuarioCreacion: string;
    HoraEstimadaLlegada: Date | string | null;
    NombreRuta: string;
    /**Cantidad de anomalias registradas en este viaje */
    CantidadAnomalias: number;
    TieneXmlCartaPorteTimbrado: boolean;
    TienexmlImpreso: boolean;
}


// WEBPACK FOOTER //
// ./app/models/viajes.ts